<template>
  <b-row class="references no-gutters">
    <b-col class="tool-border" cols="12">
      <b-col class="reduce-padding" cols="12">
        <wlpHeader :pageTitle="pageTitle"></wlpHeader>
      </b-col>
      <b-col class="page-background-gradient reduce-padding" cols="12">
        <b-row class="page-content-singles no-gutters">
          <b-row class="body-sec no-gutters">
            <b-row class="scroll no-gutters">
              <b-col
                :class="{
                  'max-width-sp': $i18n.locale == 'sp',
                  'max-width': $i18n.locale == 'en',
                }"
                cols="12"
              >
                <b-row class="no-gutters menu">
                  <b-col class="reduce-padding">
                    <div class="section-heading section-heading-start">
                      {{ $t("ref.h1-menu") }}
                    </div>

                    <p class="menu">
                      {{ $t("ref.common-ref1") }}.
                      <i>{{ $t("ref.common-ref1-1") }}</i
                      >. 2013;63(25 Pt B):1-69.
                    </p>
                    <br />
                    <div class="section-heading section-heading-start">
                      {{ $t("ref.h2-risk") }}
                    </div>
                    <p class="menu">{{ $t("ref.text-risk-1") }}</p>
                    <b-row class="no-gutters">
                      <div class="four-boxes">
                        <div class="box1">
                          <p
                            :class="{
                              'box-text-sp': $i18n.locale == 'sp',
                              'box-text': $i18n.locale == 'en',
                            }"
                          >
                            {{ $t("ref.text-risk-2") }}
                          </p>
                        </div>
                        <div class="arrow-image"></div>
                        <div class="box box2">
                          <p
                            :class="{
                              'box-text-sp': $i18n.locale == 'sp',
                              'box-text': $i18n.locale == 'en',
                            }"
                          >
                            {{ $t("ref.text-risk-3") }}
                          </p>
                        </div>
                        <div class="arrow-image"></div>
                        <div class="box box3">
                          <p
                            :class="{
                              'box-text-sp-2': $i18n.locale == 'sp',
                              'box-text': $i18n.locale == 'en',
                            }"
                          >
                            {{ $t("ref.text-risk-4") }}
                          </p>
                        </div>
                        <div class="arrow-image"></div>
                        <div class="box-4">
                          <p
                            :class="{
                              'box-4-text-sp': $i18n.locale == 'sp',
                              'box-4-text': $i18n.locale == 'en',
                            }"
                          >
                            {{ $t("ref.text-risk-5") }}
                          </p>
                        </div>
                      </div>
                    </b-row>

                    <br />
                    <div class="section-heading cancer">
                      {{ $t("ref.h3-cancer") }}
                    </div>
                    <p class="study-heading">
                      <b>{{ $t("ref.common-h-study-1") }}</b>
                      {{ $t("ref.common-h-cancer") }}
                    </p>

                    <p
                      class="blue-text"
                      :class="{ 'padding-30': $i18n.locale == 'en' }"
                    >
                      {{ $t("ref.text3-study-1") }}
                      <i>{{ $t("ref.text3-study-2") }} </i>
                      {{ $t("ref.text3-study-3") }}
                    </p>

                    <p v-if="$i18n.locale == 'sp'">
                      <i>{{ $t("ref.common-request-text") }} </i>
                    </p>

                    <p>
                      <b>{{ $t("ref.common-h-purpose") }}</b>
                      {{ $t("ref.text3-purpose") }}
                    </p>

                    <p
                      class="padding-20"
                      :class="{ 'padding-17': $i18n.locale == 'sp' }"
                    >
                      <b>{{ $t("ref.common-h-overview") }}</b>
                      {{ $t("ref.text3-overview-1")
                      }}<span v-if="$i18n.locale == 'en'">
                        <sup>2</sup>{{ $t("ref.text3-overview-1a") }}<sup>2</sup
                        >{{ $t("ref.text3-overview-1b") }}
                      </span>
                    </p>

                    <p
                      class="padding-5"
                      :class="{ 'padding-17': $i18n.locale == 'sp' }"
                    >
                      {{ $t("ref.text3-overview-2") }}
                    </p>
                    <p class="study-heading other other1">
                      <b>{{ $t("ref.common-h-otherRef") }}</b>
                    </p>
                    <p class="extra-right-padding">
                      {{ $t("ref.text3-otherRef-1") }}
                      <i>{{ $t("ref.text3-otherRef-2") }}</i>
                      {{ $t("ref.text3-otherRef-3") }}
                      <i>{{ $t("ref.common-curved-text") }}</i>
                    </p>

                    <!--dyslipidemia-->

                    <div class="section-heading dyslipidemia">
                      {{ $t("ref.h4-dyslipidemia") }}
                    </div>

                    <p class="study-heading">
                      <b>{{ $t("ref.common-h-study-1") }}</b>
                      {{ $t("ref.common-h-study-2") }}
                    </p>

                    <p class="blue-text padding-30">
                      {{ $t("ref.text4-study-1")
                      }}<i>{{ $t("ref.text4-study-2") }} </i
                      >{{ $t("ref.text4-study-3") }}
                      <i>{{ $t("ref.common-curved-text") }}</i>
                    </p>

                    <p v-if="$i18n.locale == 'sp'">
                      <i>{{ $t("ref.common-request-text") }} </i>
                    </p>

                    <p>
                      <b>{{ $t("ref.common-h-purpose") }}</b>
                      {{ $t("ref.text4-purpose") }}
                    </p>

                    <p class="padding-13">
                      <b>{{ $t("ref.common-h-overview") }}</b>
                      {{ $t("ref.text4-overview-1") }}
                    </p>
                    <p class="dyslipidemia-extra-padding">
                      {{ $t("ref.text4-overview-2") }}
                    </p>

                    <p class="study-heading">
                      <b>{{ $t("ref.common-h-study-1") }}</b>
                      {{ $t("ref.common-h-study-reduction") }}
                    </p>
                    <p class="blue-text">
                      {{ $t("ref.text5-study-1") }}
                      <i>{{ $t("ref.text5-study-2") }}</i>
                      {{ $t("ref.text5-study-3") }}
                    </p>

                    <p v-if="$i18n.locale == 'sp'">
                      <i>{{ $t("ref.common-request-text") }} </i>
                    </p>

                    <p :class="{ 'padding-5': $i18n.locale == 'sp' }">
                      <b>{{ $t("ref.common-h-purpose") }}</b>
                      {{ $t("ref.text5-purpose") }}
                    </p>

                    <p class="padding-20">
                      <b>{{ $t("ref.common-h-overview") }}</b>
                      {{ $t("ref.text5-overview-1") }}
                    </p>
                    <p :class="{ 'padding-13': $i18n.locale == 'en' }">
                      {{ $t("ref.text5-overview-2") }}
                    </p>

                    <p class="blue-text">
                      {{ $t("ref.text5-overview-3") }}
                      <i>{{ $t("ref.text5-overview-4") }} </i>
                      {{ $t("ref.text5-overview-5") }}
                    </p>

                    <p v-if="$i18n.locale == 'sp'">
                      <i>{{ $t("ref.common-request-text") }} </i>
                    </p>

                    <p>
                      <b>{{ $t("ref.common-h-purpose") }}</b>
                      {{ $t("ref.text6-purpose") }}
                    </p>

                    <p class="padding-15">
                      <b>{{ $t("ref.common-h-overview") }}</b>
                      {{ $t("ref.text6-overview") }}
                    </p>

                    <p class="study-heading other">
                      <b>{{ $t("ref.common-h-otherRef") }}</b>
                    </p>
                    <p class="dyslipidemia-extra-padding">
                      {{ $t("ref.common-ref1") }}.
                      <i>{{ $t("ref.common-ref1-1") }}</i
                      >. {{ $t("ref.text6-otherRef-3") }}
                    </p>
                    <p class="padding-15">
                      {{ $t("ref.text6-otherRef-4") }}
                    </p>

                    <!--<br> hypertension-->

                    <div class="section-heading hypertension">
                      {{ $t("ref.h7-hypertension") }}
                    </div>

                    <p class="study-heading">
                      <b>{{ $t("ref.common-h-study-1") }}</b>
                      {{ $t("ref.common-h-study-2") }}
                    </p>

                    <p class="blue-text padding-15">
                      {{ $t("ref.text7-study-1") }}
                      <i>{{ $t("ref.text7-study-2") }}</i
                      >{{ $t("ref.text7-study-3")
                      }}<i> {{ $t("ref.common-curved-text") }}</i>
                    </p>

                    <p v-if="$i18n.locale == 'sp'">
                      <i>{{ $t("ref.common-request-text") }} </i>
                    </p>

                    <p class="padding-20">
                      <b>{{ $t("ref.common-h-purpose") }}</b>
                      {{ $t("ref.text7-purpose") }}
                    </p>

                    <p class="padding-15">
                      <b>{{ $t("ref.common-h-overview") }}</b>
                      {{ $t("ref.text7-overview-1") }}
                    </p>
                    <p :class="{ 'padding-20': $i18n.locale == 'en' }">
                      {{ $t("ref.text7-overview-2") }}
                    </p>

                    <p class="study-heading">
                      <b>{{ $t("ref.common-h-study-1") }}</b>
                      {{ $t("ref.common-h-study-reduction") }}
                    </p>
                    <p
                      class="blue-text"
                      :class="{
                        'dyslipidemia-extra-padding1': $i18n.locale == 'en',
                      }"
                    >
                      {{ $t("ref.common-ref1") }}.
                      <i>{{ $t("ref.common-ref1-1") }}</i
                      >. {{ $t("ref.text8-study-3") }}
                    </p>

                    <p v-if="$i18n.locale == 'sp'">
                      <i>{{ $t("ref.common-request-text") }} </i>
                    </p>

                    <p class="dyslipidemia-extra-padding">
                      <b>{{ $t("ref.common-h-purpose") }}</b>
                      {{ $t("ref.text8-purpose") }}
                    </p>
                    <p class="padding-15 dyslipidemia-extra-padding">
                      <b>{{ $t("ref.common-h-overview") }}</b>
                      {{ $t("ref.text8-overview-1") }}
                    </p>
                    <p :class="{ 'padding-15': $i18n.locale == 'sp' }">
                      {{ $t("ref.text8-overview-2") }}
                    </p>

                    <p class="study-heading other">
                      <b>{{ $t("ref.common-h-otherRef") }}</b>
                    </p>
                    <p>
                      {{ $t("ref.text8-otherRef-1") }}
                      <i>{{ $t("ref.text8-otherRef-2") }}</i
                      >{{ $t("ref.text8-otherRef-3") }}
                    </p>
                    <!--INFERTILITY PCOS-->

                    <div class="section-heading pcos">
                      {{ $t("ref.h9-pcos") }}
                    </div>
                    <p class="study-heading">
                      <b>{{ $t("ref.common-h-study-1") }}</b>
                      {{ $t("ref.common-h-study-2") }}
                    </p>
                    <p class="blue-text">
                      {{ $t("ref.text9-study-1") }}
                      <i> {{ $t("ref.text9-study-2") }}</i> 2002;13(2):184-190.
                      <i>{{ $t("ref.common-curved-text") }}</i>
                    </p>

                    <p v-if="$i18n.locale == 'sp'">
                      <i>{{ $t("ref.common-request-text") }} </i>
                    </p>

                    <p>
                      <b>{{ $t("ref.common-h-purpose") }}</b>
                      {{ $t("ref.text9-purpose") }}
                    </p>
                    <p
                      :class="{
                        'padding-10': $i18n.locale == 'en',
                        'padding-6': $i18n.locale == 'sp',
                      }"
                    >
                      <b>{{ $t("ref.common-h-overview") }}</b>
                      {{ $t("ref.text9-overview-1")
                      }}<span v-if="$i18n.locale == 'en'"
                        ><sup>2</sup>{{ $t("ref.text9-overview-1a") }}</span
                      >
                    </p>

                    <p class="padding-15">
                      {{ $t("ref.text9-overview-2")
                      }}<span v-if="$i18n.locale == 'en'"
                        ><sup>2</sup>{{ $t("ref.text9-overview-2a")
                        }}<sup>2</sup>{{ $t("ref.text9-overview-2b") }}</span
                      >
                    </p>

                    <p class="menu">
                      <b>{{ $t("ref.common-h-study-1") }}</b>
                      {{ $t("ref.common-h-study-reduction") }}
                    </p>
                    <p class="blue-text padding-25 blue-text-inf">
                      {{ $t("ref.text10-study-1") }}
                      <i>{{ $t("ref.text10-study-2") }}</i>
                      2003;18(9):1928-1932.
                    </p>

                    <p v-if="$i18n.locale == 'sp'">
                      <i>{{ $t("ref.common-request-text") }} </i>
                    </p>

                    <p class="padding-14">
                      <b>{{ $t("ref.common-h-purpose") }}</b>
                      {{ $t("ref.text10-purpose") }}
                    </p>
                    <p class="padding-15">
                      <b>{{ $t("ref.common-h-overview") }}</b>
                      {{ $t("ref.text10-overview-1") }}
                    </p>
                    <p
                      :class="{
                        'padding-15': $i18n.locale == 'en',
                        'padding-13': $i18n.locale == 'sp',
                      }"
                    >
                      {{ $t("ref.text10-overview-2a") }}&#8209;{{
                        $t("ref.text10-overview-2b")
                      }}{{ "\xa0" }}{{ $t("ref.text10-overview-2c") }}
                    </p>
                    <p class="study-heading other">
                      <b>{{ $t("ref.common-h-otherRef") }}</b>
                    </p>
                    <p>
                      {{ $t("ref.text10-otherRef-1") }}
                      <i>AACE/ACE.</i> 2016;22:Supp3:1-205.
                    </p>

                    <p :class="{ 'padding-11': $i18n.locale == 'sp' }">
                      {{ $t("ref.text10-otherRef-2") }}
                      <span :class="{ 'italic-text': $i18n.locale == 'en' }"
                        >J Clin Endocrinol Metab.</span
                      >
                      2013;98(12):4565-4592.
                    </p>

                    <!--NAFLD-->

                    <!-- <div class ="nafld section-heading">{{$t('ref.h11-nafld')}}</div>
                     <p class = "study-heading menu"><b>{{$t('ref.common-h-study-1')}}</b> {{$t('ref.common-h-study-2')}}</p>
                     <p class ="blue-text">
                         <br>
                        {{$t('ref.text11-study-1')}} <i>{{$t('ref.text11-study-2')}}</i>. 2017;26:292-300. <i>{{$t('ref.common-linear-text')}}</i>
                     </p>
                     
                     <p v-if="$i18n.locale=='sp'" ><i>{{$t('ref.common-request-text')}} </i></p>
                     
                     <p class="padding-15">
                    <b>{{$t('ref.common-h-purpose')}}</b> {{$t('ref.text11-purpose')}}</p>
                    
                    <p class="padding-10">
                        <b>{{$t('ref.common-h-overview')}}</b>
                       {{$t('ref.text11-overview-1a')}}<sup>1</sup>{{$t('ref.text11-overview-1b')}}
                     </p>
                     <p class="padding-15">
                     {{$t('ref.text11-overview-2')}}
                     </p>
                     <p class="study-heading other"><b>{{$t('ref.common-h-otherRef')}}</b></p>
                       <p class="padding-10">{{$t('ref.text11-otherRef-1')}} <i>{{$t('ref.text11-otherRef-2')}}</i>. 2010;33(10):2156-2163.</p>
                      -->
                    <!--OSTEOARTHRITIS-->

                    <div class="osteoarthritis section-heading">
                      {{ $t("ref.h12-title") }}
                    </div>
                    <p class="study-heading">
                      <b>{{ $t("ref.common-h-study-1") }}</b>
                      {{ $t("ref.common-h-study-2") }}
                    </p>
                    <p class="blue-text padding-15">
                      {{ $t("ref.text12-study-1") }}
                      <i>JAMA</i>. 1999;282(16):1523-1529.
                      <i>{{ $t("ref.common-linear-text") }}</i>
                    </p>

                    <p v-if="$i18n.locale == 'sp'">
                      <i>{{ $t("ref.common-request-text") }} </i>
                    </p>

                    <p class="padding-15">
                      <b>{{ $t("ref.common-h-purpose") }}</b>
                      {{ $t("ref.text12-purpose") }}
                    </p>
                    <p class="padding-15">
                      <b>{{ $t("ref.common-h-overview") }}</b>
                      {{ $t("ref.text12-overview-1")
                      }}<span v-if="$i18n.locale == 'en'"
                        ><sup>2</sup>{{ $t("ref.text12-overview-1a") }}</span
                      >
                    </p>

                    <p
                      class="padding-10"
                      :class="{ 'padding-15': $i18n.locale == 'sp' }"
                    >
                      {{ $t("ref.text12-overview-2") }}
                    </p>
                    <p class="study-heading">
                      <b>{{ $t("ref.common-h-study-1") }}</b>
                      {{ $t("ref.common-h-study-reduction") }}
                    </p>
                    <p class="blue-text padding-20">
                      {{ $t("ref.text13-study-1") }}
                      <i>{{ $t("ref.text13-study-2") }}</i
                      >. 2018;70(11):1569-1575.
                      <i>{{ $t("ref.common-linear-text") }}</i>
                    </p>

                    <p v-if="$i18n.locale == 'sp'">
                      <i>{{ $t("ref.common-request-text") }} </i>
                    </p>

                    <p class="padding-10">
                      <b>{{ $t("ref.common-h-purpose") }}</b>
                      {{ $t("ref.text13-purpose") }}
                    </p>
                    <p
                      :class="{
                        'padding-13': $i18n.locale == 'sp',
                        'padding-15': $i18n.locale == 'en',
                      }"
                    >
                      <b>{{ $t("ref.common-h-overview") }}</b>
                      {{ $t("ref.text13-overview-1")
                      }}<span v-if="$i18n.locale == 'en'"
                        ><sup>2</sup>{{ $t("ref.text13-overview-1a")
                        }}<sup>2</sup>{{ $t("ref.text13-overview-1b") }}</span
                      >
                    </p>
                    <p
                      :class="{
                        'padding-13': $i18n.locale == 'sp',
                        'padding-13': $i18n.locale == 'en',
                      }"
                    >
                      {{ $t("ref.text13-overview-2") }}
                    </p>
                    <p class="padding-13">
                      {{ $t("ref.text13-overview-3") }}
                    </p>
                    <p class="study-heading other">
                      <b>{{ $t("ref.common-h-otherRef") }}</b>
                    </p>
                    <p>{{ $t("ref.text13-otherRef-1") }} 2012:1-8.</p>
                    <p>
                      {{ $t("ref.text13-otherRef-2") }}
                      <i>JAMA</i>. {{ $t("ref.text13-otherRef-3") }}<br />
                      {{ $t("ref.text13-otherRef-4") }}
                    </p>
                    <!--YYPE 2 DIABETES-->
                    <div class="type2Diabetes section-heading">
                      {{ $t("ref.h14-title") }}
                    </div>
                    <p class="study-heading">
                      <b>{{ $t("ref.common-h-study-1") }}</b>
                      {{ $t("ref.common-h-study-2") }}
                    </p>
                    <p class="blue-text padding-15">
                      {{ $t("ref.text14-study-1")
                      }}<i>{{ $t("ref.text14-study-2") }}</i
                      >. 2014:1-23. <i>{{ $t("ref.common-curved-text") }}</i>
                    </p>

                    <p v-if="$i18n.locale == 'sp'">
                      <i>{{ $t("ref.common-request-text") }} </i>
                    </p>

                    <p class="padding-10">
                      <b>{{ $t("ref.common-h-purpose") }}</b>
                      {{ $t("ref.text14-purpose") }}
                    </p>
                    <p
                      :class="{
                        'padding-17': $i18n.locale == 'sp',
                        'padding-20': $i18n.locale == 'en',
                      }"
                    >
                      <b>{{ $t("ref.common-h-overview") }}</b>
                      {{ $t("ref.text14-overview-1") }}
                    </p>
                    <p class="padding-10">{{ $t("ref.text14-overview-2") }}</p>

                    <p class="study-heading menu">
                      <b>{{ $t("ref.common-h-study-1") }}</b>
                      {{ $t("ref.common-h-study-reduction") }}
                    </p>
                    <p class="blue-text padding-10">
                      <br />
                      {{ $t("ref.common-ref1") }}.
                      <i>{{ $t("ref.common-ref1-1") }}</i
                      >. 2013;63(25 Pt B):1-69.
                    </p>

                    <p v-if="$i18n.locale == 'sp'">
                      <i>{{ $t("ref.common-request-text") }} </i>
                    </p>

                    <p class="padding-10">
                      <b>{{ $t("ref.common-h-purpose") }}</b>
                      {{ $t("ref.text15-purpose") }}
                    </p>
                    <p class="padding-15">
                      <b>{{ $t("ref.common-h-overview") }}</b>
                      {{ $t("ref.text15-overview-1") }}
                    </p>
                    <p class="padding-13">
                      {{ $t("ref.text15-overview-2") }}
                    </p>

                    <!--YEARS OF LIFE LOST-->

                    <div class="lifeLost section-heading">
                      {{ $t("ref.h16-title") }}
                    </div>
                    <p class="study-heading menu">
                      <b>{{ $t("ref.common-h-study-1") }}</b>
                      {{ $t("ref.common-h-study-2") }}
                    </p>
                    <br />
                    <p
                      class="blue-text"
                      :class="{ 'padding-15': $i18n.locale == 'en' }"
                    >
                      {{ $t("ref.text16-study-1")
                      }}<i>. {{ $t("ref.text16-study-2") }}</i
                      >. 2015;3:114-122.
                      <i>{{ $t("ref.common-linear-text") }}</i>
                    </p>

                    <p v-if="$i18n.locale == 'sp'">
                      <i>{{ $t("ref.common-request-text") }} </i>
                    </p>

                    <p :class="{ 'padding-20': $i18n.locale == 'en' }">
                      <b>{{ $t("ref.common-h-purpose") }}</b>
                      {{ $t("ref.text16-purpose") }}
                    </p>
                    <p
                      :class="{
                        'padding-13': $i18n.locale == 'sp',
                        'padding-10': $i18n.locale == 'en',
                      }"
                    >
                      <b>{{ $t("ref.common-h-overview") }}</b>
                      {{ $t("ref.text16-overview-1")
                      }}<span v-if="$i18n.locale == 'en'"
                        ><sup>2</sup>{{ $t("ref.text16-overview-1a")
                        }}<sup>2</sup>{{ $t("ref.text16-overview-1b") }}</span
                      >
                    </p>
                    <p
                      :class="{
                        'padding-13': $i18n.locale == 'sp',
                        'padding-10': $i18n.locale == 'en',
                      }"
                    >
                      {{ $t("ref.text16-overview-2") }}
                    </p>
                    <p
                      :class="{
                        'padding-11': $i18n.locale == 'sp',
                        'padding-17': $i18n.locale == 'en',
                      }"
                    >
                      {{ $t("ref.text16-overview-3")
                      }}<span v-if="$i18n.locale == 'en'"
                        ><sup>2</sup>{{ $t("ref.text16-overview-3a") }}</span
                      >
                    </p>

                    <!--<br>-->

                    <div class="info section-heading">
                      {{ $t("ref.h17-title") }}
                    </div>
                    <div class="section-sub-heading">
                      {{ $t("ref.subh1-other") }}
                    </div>
                    <ul class="more-info-text padding-20">
                      <li class="more-info-bullets">
                        {{ $t("ref.other1") }}. 2016:1-10.
                      </li>
                      <li class="more-info-bullets">
                        {{ $t("ref.other2") }}. <i>{{ $t("ref.other2-1") }}</i
                        >. 2014:1-23. <i>{{ $t("ref.common-curved-text") }}</i>
                      </li>
                      <li class="more-info-bullets">
                        {{ $t("ref.common-ref1") }}.
                        <i>{{ $t("ref.common-ref1-1") }}</i
                        >. 2013;63(25 Pt B):1-69.
                      </li>
                      <li class="more-info-bullets">
                        {{ $t("ref.other4") }} {{ $t("ref.other4-1") }} <br />
                        {{ $t("ref.other4-2") }}
                      </li>
                      <li class="more-info-bullets">
                        {{ $t("ref.other5") }}. <i> {{ $t("ref.other5-1") }}</i
                        >. 2005;165:2408-2013.
                      </li>
                      <li class="more-info-bullets">
                        {{ $t("ref.other6") }}. <i>{{ $t("ref.other6-1") }}</i
                        >. 2017;5:1-6.
                      </li>
                    </ul>
                    <div class="section-sub-heading">
                      {{ $t("ref.subh1-covid") }}
                    </div>
                    <ul class="more-info-text">
                      <li class="more-info-bullets">{{ $t("ref.covid1") }}</li>
                      <li class="more-info-bullets">
                        {{ $t("ref.covid2") }}. <i>{{ $t("ref.covid2-1") }}</i
                        >. {{ $t("ref.covid2-2") }} <br />
                        {{ $t("ref.covid2-3") }}
                      </li>
                    </ul>
                    <div class="section-sub-heading">
                      {{ $t("ref.subh1-goals") }}
                    </div>
                    <ul class="more-info-text">
                      <li
                        class="more-info-bullets"
                        :class="{ 'padding-10': $i18n.locale == 'sp' }"
                      >
                        {{ $t("ref.goals1") }}. <i>{{ $t("ref.goals2") }}</i
                        >. 2013;63(25 Pt B):1-69.
                      </li>
                    </ul>
                    <div class="section-sub-heading">
                      {{ $t("ref.subh1-cancer") }}
                    </div>
                    <ul class="more-info-text">
                      <li class="more-info-bullets padding-10">
                        {{ $t("ref.cancer1") }}
                        https://www.cdc.gov/media/releases<wbr />/2017/p1003-vs-cancer-obesity<wbr />.html.
                      </li>
                      <li class="more-info-bullets">
                        {{ $t("ref.cancer2") }}. <i>NEJM</i>. 2016;
                        375(8):794-798.
                      </li>
                    </ul>
                    <div class="section-sub-heading">
                      {{ $t("ref.subh1-dyslipidemia") }}
                    </div>
                    <ul class="more-info-text">
                      <li class="more-info-bullets">
                        {{ $t("ref.dyslipidemia1") }}. <i>NCBI</i>. 2018:1-67.
                      </li>
                    </ul>
                    <div class="section-sub-heading">
                      {{ $t("ref.subh1-hypertension") }}
                    </div>
                    <ul class="more-info-text">
                      <li
                        class="more-info-bullets"
                        :class="{ 'padding-10': $i18n.locale == 'sp' }"
                      >
                        {{ $t("ref.common-ref1") }}.
                        <i>{{ $t("ref.common-ref1-1") }}</i
                        >. 2013;63(25 Pt B):1-69.
                      </li>
                      <li class="more-info-bullets">
                        {{ $t("ref.hypertension2") }}.
                        <i>{{ $t("ref.hypertension2-1") }}</i
                        >. 2013;21(1): 8-24.
                      </li>
                    </ul>
                    <div
                      v-if="$i18n.locale == 'sp'"
                      class="section-sub-heading"
                    >
                      {{ $t("ref.subh1-nafld") }}
                    </div>
                    <ul v-if="$i18n.locale == 'sp'" class="more-info-text">
                      <li class="more-info-bullets">
                        {{ $t("ref.nafld1") }}. <i>{{ $t("ref.nafld1-1") }}</i
                        >. 2016;17:510-519.
                      </li>
                      <li class="more-info-bullets">
                        {{ $t("ref.nafld2") }}. <i>{{ $t("ref.nafld2-1") }}</i
                        >. 2010;51(1):121-129.
                      </li>
                      <li class="more-info-bullets padding-20">
                        {{ $t("ref.nafld3") }}. <i>{{ $t("ref.nafld3-1") }}</i
                        >. 2011;9:524-530.
                      </li>
                    </ul>
                    <div class="section-sub-heading">
                      {{ $t("ref.subh1-osteoarthritis") }}
                    </div>
                    <ul class="more-info-text">
                      <li class="more-info-bullets padding-25">
                        {{ $t("ref.osteoarthritis1") }}. <i>JAMA</i>.
                        2013;310(2):1263-1273.
                      </li>
                      <li class="more-info-bullets">
                        {{ $t("ref.osteoarthritis2") }}. 2012:1-8.
                      </li>
                    </ul>
                    <div class="section-sub-heading">
                      {{ $t("ref.subh1-pcos") }}
                    </div>
                    <ul class="more-info-text">
                      <li
                        class="more-info-bullets"
                        :class="{ 'padding-10': $i18n.locale == 'sp' }"
                      >
                        {{ $t("ref.pcos1") }}. <i>{{ $t("ref.pcos1-1") }}</i
                        >. 2009;92(6):1966-1982.
                      </li>
                    </ul>

                    <div class="section-sub-heading">
                      {{ $t("ref.subh1-diabetes") }}
                    </div>
                    <ul class="more-info-text">
                      <li
                        class="more-info-bullets"
                        :class="{ 'padding-10': $i18n.locale == 'sp' }"
                      >
                        {{ $t("ref.common-ref1") }}.
                        <i>{{ $t("ref.common-ref1-1") }}</i
                        >. 2013;63(25 Pt B):1-69.
                      </li>
                      <li class="more-info-bullets padding-45">
                        {{ $t("ref.diabetes2") }}. 2013:1-R-32.
                      </li>
                    </ul>
                    <div class="section-sub-heading">
                      {{ $t("ref.subh1-lifelost") }}
                    </div>
                    <ul class="more-info-text">
                      <li class="more-info-bullets padding-15">
                        {{ $t("ref.lifelost1") }}
                        <i>{{ $t("ref.lifelost1-1") }}</i
                        >. 2015;3:114-122.
                        <i>{{ $t("ref.common-linear-text") }}</i>
                      </li>
                      <li
                        class="more-info-bullets"
                        :class="{ 'padding-10': $i18n.locale == 'sp' }"
                      >
                        {{ $t("ref.common-ref1") }}.
                        <i>{{ $t("ref.common-ref1-1") }}</i
                        >. 2013;63(25 Pt B):1-69.
                      </li>

                      <li class="low-spacing more-info-bullets padding-45">
                        {{ $t("ref.lifelost3") }}. 2013:1-R-32.
                      </li>
                    </ul>
                    <div class="section-sub-heading">
                      {{ $t("ref.subh1-weightloss") }}
                    </div>
                    <ul class="more-info-text">
                      <li
                        class="more-info-bullets"
                        :class="{ 'padding-10': $i18n.locale == 'sp' }"
                      >
                        {{ $t("ref.common-ref1") }}.
                        <i>{{ $t("ref.common-ref1-1") }}</i
                        >. 2013;63(25 Pt B):1-69.
                      </li>
                    </ul>
                    <div class="section-sub-heading">
                      {{ $t("ref.subh1-trained") }}
                    </div>
                    <ul class="more-info-text">
                      <li
                        class="more-info-bullets"
                        :class="{ 'padding-10': $i18n.locale == 'sp' }"
                      >
                        {{ $t("ref.common-ref1") }}.
                        <i>{{ $t("ref.common-ref1-1") }}</i
                        >. 2013;63(25 Pt B):1-69.
                      </li>
                    </ul>
                    <div class="section-sub-heading">
                      {{ $t("ref.subh1-lifestyle") }}
                    </div>
                    <ul class="more-info-text last-para">
                      <li
                        class="more-info-bullets"
                        :class="{ 'padding-10': $i18n.locale == 'sp' }"
                      >
                        {{ $t("ref.common-ref1") }}.
                        <i>{{ $t("ref.common-ref1-1") }}</i
                        >. 2013;63(25 Pt B):1-69.
                      </li>
                    </ul>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-row>
        </b-row>

        <wlpNavigation
          :navButtons="['info', 'tnc', 'previous', 'menu2']"
          :currentScreen="1"
          :btn3Absent="true"
          :btn4Absent="true"
          :btn5Absent="true"
        ></wlpNavigation>
      </b-col>
    </b-col>
  </b-row>
</template>


<script>
import { mapGetters } from "vuex";
import scrollMixin from "../mixins/scrollMixin";
import wlpNavigation from "../components/wlpNavigation.vue";
import wlpHeader from "../components/wlpHeader.vue";

export default {
  name: "references",
  mixins: [scrollMixin],
  computed: {
    ...mapGetters("userData", ["userData"]),
  },
  mounted: function () {
    this.$nextTick(function () {
      if (
        this.userData.refAnchor == "undefined" ||
        this.userData.refAnchor == ""
      ) {
        this.scrollToTop();
      } else {
        document.querySelector("." + this.userData.refAnchor).scrollIntoView();
        //   scroll to error for iphones
        //   if ('parentIFrame' in window) {
        //      var elmTop = document.querySelector('.haserror').getBoundingClientRect().top;
        //      if (elmTop > 0) {
        //       parentIFrame.scrollToOffset(0, elmTop - 200);
        //      }
        //   }
      }
    });
  },
  components: {
    wlpNavigation: wlpNavigation,
    wlpHeader: wlpHeader,
  },

  data() {
    return {
      pageTitle: this.$t("ref.pageTitle"),
    };
  },
};
</script>


<style lang="scss" scoped>
</style>
